// Feature: docs/features/edf-generation.md
import React, { useState, useContext } from 'react';
import {
  Box,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  VStack,
  Text
} from '@chakra-ui/react';
import HeaderMenus from '../HeaderMenus';
import EDFUploadTab from './EDFUploadTab';
import EDFJobsTab from './EDFJobsTab';
import { AppContext } from '../AppContext';

const EDFManager = () => {
  const { accessToken } = useContext(AppContext);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleJobCreated = () => {
    // Trigger a refresh of the jobs list when a new job is created
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Box minH="100vh" bg="gray.50">
      <HeaderMenus />
      <Box maxW="7xl" mx="auto" px={4} py={8}>
        <VStack align="stretch" spacing={6}>
          <Box>
            <Heading size="lg" mb={2}>EDF Generation</Heading>
            <Text color="gray.600">
              Generate EDF files by submitting Case IDs. Monitor job status and download completed files.
            </Text>
          </Box>

          <Box bg="white" shadow="sm" rounded="lg" p={6}>
            <Tabs colorScheme="blue" variant="enclosed">
              <TabList>
                <Tab>Generate EDF</Tab>
                <Tab>Job History</Tab>
              </TabList>

              <TabPanels>
                <TabPanel px={0} pt={6}>
                  <EDFUploadTab onJobCreated={handleJobCreated} />
                </TabPanel>
                <TabPanel px={0} pt={6}>
                  <EDFJobsTab refreshTrigger={refreshTrigger} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default EDFManager;
